import { render } from "./Encuestas.vue?vue&type=template&id=30262f34&scoped=true"
import script from "./Encuestas.vue?vue&type=script&lang=js"
export * from "./Encuestas.vue?vue&type=script&lang=js"

import "./Encuestas.vue?vue&type=style&index=0&id=30262f34&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30262f34"]])

export default __exports__